import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_humanize_time = _resolveComponent("humanize-time")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponentMap(_ctx.userNotification.notification.type)), _mergeProps({
    data: _ctx.userNotification.notification.data,
    active: _ctx.userNotification.readAt === null,
    "active-class": "bg-deep-orange-1 text-grey-9"
  }, _ctx.$attrs, { clickable: "" }), {
    default: _withCtx(() => [
      _createVNode(_component_humanize_time, {
        time: _ctx.userNotification.notification.occurredAt
      }, null, 8, ["time"]),
      _withDirectives(_createVNode(_component_q_btn, {
        size: "sm",
        label: "Mark as read",
        loading: _ctx.isLoading,
        flat: "",
        "no-caps": "",
        rounded: "",
        onClick: _withModifiers(_ctx.markRead, ["stop"])
      }, null, 8, ["loading", "onClick"]), [
        [_vShow, _ctx.isUnread]
      ])
    ]),
    _: 1
  }, 16, ["data", "active"]))
}